import { IncidentesParamsDTO } from "@/application";
import { Header, useVisita } from "@/presentation";
import { Form } from "@/presentation/components/Forms/Form/Form";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";
import { useAuthContext } from "@/presentation/context";
import { useIncidente } from "@/presentation/hooks/useIncidente";
import { useSimple } from "@/presentation/hooks/useSimple";
import { routes } from "@/presentation/router";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function NuevaVisita() {
    const navigate = useNavigate();
    const { user, logout } = useAuthContext();
    const {
        data: incidentes,
        loadAll: loadAllIncidentes,
    } = useIncidente();
    const {
        data: usuarios,
      } = useSimple('usuarios');
      const optionsUsuarios = useMemo(
          () =>
            usuarios.map((usuario) => ({
              value: usuario.id,
              label: `${usuario.nombre} ${usuario.apellido}`,
            })),
          [usuarios]
        );


    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const handleOpenDrawer = () => {
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleLogout = async () => {
        await logout();
        setIsDrawerOpen(false);
        navigate(routes.login, { replace: true });
    };
    const params: IncidentesParamsDTO = {
        pages: 1,
        sort: 'iniciado',
        order: 'desc',
        tipo: 4,
        id_visita: -1,
    };

    useEffect(() => {
        loadAllIncidentes(params);
    }, [loadAllIncidentes]);
    console.log(incidentes)
    const incidentesOptions = incidentes.map(
        (incid) => ({
            value: incid.id,
            label: `${incid.id} - ${incid.equipo} - ${incid.ubicacion}`,
        })
    );


    const { create } = useVisita();

    const handleSubmitValues = async (
        values: Record<string, unknown>
    ) => {
        const simple = {
            fecha: String(values.fecha),
            ubicacion_generica: String(values.ubicacion_generica ?? ""),
            incidentes: (values.incidentes as number[] | undefined) ?? [],
            usuarios: (values.usuarios as number[] | undefined) ?? [],
        };
        await create(simple);
        navigate(routes.visitas, { replace: true });
    };







    return (
        <div>
            <Header title={`Nueva Visita`} onMenuClick={handleOpenDrawer} />

            <AppDrawer
                isOpen={isDrawerOpen}
                user={user}
                onClose={handleCloseDrawer}
                onLogout={handleLogout}
            />

            <main style={{ padding: '24px' }}>
                <Form
                    fields={[
                        {
                            name: 'fecha',
                            label: 'Fecha',
                            type: 'date',
                        },
                        {
                            name: 'ubicacion_generica',
                            label: 'Ubicación Genérica',
                            type: 'text',
                        },
                        {
                            name: 'incidentes',
                            label: 'Incidentes',
                            type: 'select',
                            multiple: true,
                            options: incidentesOptions,
                            optional: true
                        },
                        {
                            name: 'usuarios',
                            label: 'Usuarios',
                            type: 'select',
                            multiple: true,
                            options: optionsUsuarios
                        }
                    ]}


                    submitLabel={
                        `Crear Visita`
                    }
                    onSubmit={handleSubmitValues}

                />


            </main>


        </div>
    );
}